import { NgModule } from "@angular/core";

import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";

import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HeaderComponent } from "./layout/header/header.component";
import { PageLoaderComponent } from "./layout/page-loader/page-loader.component";
import { SidebarComponent } from "./layout/sidebar/sidebar.component";
import { RightSidebarComponent } from "./layout/right-sidebar/right-sidebar.component";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { fakeBackendProvider } from "./core/interceptor/fake-backend";
import { ErrorInterceptor } from "./core/interceptor/error.interceptor";
import { JwtInterceptor } from "./core/interceptor/jwt.interceptor";
import { ApiLoggingInterceptor } from './interceptors/api-logging.interceptor';
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ClickOutsideModule } from "ng-click-outside";

import {
    HttpClientModule,
    // HTTP_INTERCEPTORS,
    HttpClient,
    HTTP_INTERCEPTORS,
} from "@angular/common/http";

import { LoadingBarRouterModule } from "@ngx-loading-bar/router";
import { NgScrollbarModule } from "ngx-scrollbar";
import { MatSelectModule } from "@angular/material/select";
import { ComponentsModule } from "./shared/components/components.module";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PatientLayoutComponent } from "./patient-queuing/layout/patient-layout.component";
import { PrintPageComponent } from './print-page/print-page.component';
import { PrescriptionHeaderComponent } from './print-page/header/prescription-header/prescription-header.component';
import { PrescriptionFooterComponent } from './print-page/footer/prescription-footer/prescription-footer.component';
import { PrescriptionBodyComponent } from './print-page/body/prescription-body/prescription-body.component';
import { DailyOPDActivitySummaryComponent } from './daily-opdactivity-summary/daily-opdactivity-summary.component';
import { AddStoreTypeComponent } from './Store/add-store-type/add-store-type.component';
import { AddStoreComponent } from './Store/add-store/add-store.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { CUSTOM_DATE_FORMATS, CustomDateAdapter } from "./custom-date-adapter";

export function createTranslateLoader(http: HttpClient): any {
    return new TranslateHttpLoader(http, "assets/i18n/", ".json");
}

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        PageLoaderComponent,
        SidebarComponent,
        RightSidebarComponent,
        AuthLayoutComponent,
        MainLayoutComponent,
        PatientLayoutComponent,
        PrintPageComponent,
        PrescriptionHeaderComponent,
        PrescriptionFooterComponent,
        PrescriptionBodyComponent,
        DailyOPDActivitySummaryComponent,
        AddStoreTypeComponent,
        AddStoreComponent,
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
        },
        {
            provide: MAT_DATE_FORMATS,
            useValue: CUSTOM_DATE_FORMATS,
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'en-IN',
        },
        { provide: LocationStrategy, useClass: HashLocationStrategy },

        { provide: HTTP_INTERCEPTORS, useClass: ApiLoggingInterceptor, multi: true },
        // { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        fakeBackendProvider,

    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        ClickOutsideModule,
        LoadingBarRouterModule,
        NgScrollbarModule,
        MatSelectModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
            isolate: false
        }),
        // core & shared
        CoreModule,
        SharedModule.forRoot(),
        ComponentsModule,
        NgxMatSelectSearchModule,
        HttpClientModule
    ]
})
export class AppModule { }
